interface ChatMessageUser {
  _id?: string | number | null;
  id?: string | number | null;
}

interface ChatRoomMessage {
  roomId?: string | null;
  user?: ChatMessageUser | null;
}

export const getAdminChatRoomId = (
  userId: string | number | null | undefined
): string | null =>
  userId != null && userId !== '' ? `${userId}_admin` : null;

export const getAdminChatJoinPayload = (
  userId: string | number | null | undefined
): { roomId: string; userId: string | number } | null => {
  const roomId = getAdminChatRoomId(userId);
  if (!roomId || userId == null || userId === '') {
    return null;
  }
  return { roomId, userId };
};

export const isOutgoingUserChatMessage = (
  message: ChatRoomMessage | null | undefined,
  currentUserId: string | number | null | undefined
): boolean => {
  if (currentUserId == null || currentUserId === '') {
    return false;
  }
  const senderId = message?.user?._id ?? message?.user?.id;
  if (senderId == null) {
    return false;
  }
  return String(senderId) === String(currentUserId);
};

export const isAdminChatMessageForRoom = (
  message: ChatRoomMessage | null | undefined,
  roomId: string | null | undefined
): boolean => !roomId || !message?.roomId || message.roomId === roomId;
